import type { RemovableRef } from '@vueuse/core';
import type { MaybeRefOrGetter } from 'vue';
import { useLocalStorage } from '@vueuse/core';
import { computed, toValue } from 'vue';
import { storageKey } from '#layers/base/utils/storage-key';

/**
 * `useLocalStorage` scoped to Studio's browser-storage namespace: the `name` is
 * routed through `storageKey()` so every entry shares the `monospace-studio:` prefix.
 * A reactive `name` re-binds storage when it changes, matching VueUse behaviour.
 *
 * @param name - The unprefixed key name (plain, ref, or getter)
 * @param defaults - Initial value used when nothing is stored yet
 * @returns The VueUse `RemovableRef` bound to the prefixed key
 */
export function useScopedLocalStorage<T>(
	name: MaybeRefOrGetter<string>,
	defaults: MaybeRefOrGetter<T>,
): RemovableRef<T> {
	const key = computed(() => storageKey(toValue(name)));
	return useLocalStorage(key, defaults);
}
